import React from 'react';
import PropTypes from 'prop-types';
import { ChevronButtonWrapper, Chevron } from './styled';

const ChevronButton = ({ isOpen, onClick, color = 'confetti', children }) => {
  return (
    <ChevronButtonWrapper onClick={onClick} color={color} $isOpen={isOpen}>
      {children}
      <Chevron $isOpen={isOpen} />
    </ChevronButtonWrapper>
  );
};

ChevronButton.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  children: PropTypes.node.isRequired,
  onClick: PropTypes.func.isRequired,
  color: PropTypes.string
};

export default ChevronButton;
